import { isNaN, omit, reduce, uniqueId } from 'lodash/fp'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

const ID_PREFIX = 'vendor_'

export default {
  data () {
    return {
      vendors: [],
      vendorsExpand: null
    }
  },
  computed: {
    vendorsListErrors () {
      const errors = []
      return errors
    },
    vendorsErrors () {
      console.log('computing vendorsErrors')
      console.log('this.$v.vendors', this.$v.vendors)
      let errors = {}

      console.log('this.$v.vendors.$each', this.$v.vendors.$each)

      for (let index in this.$v.vendors.$each) {
        if (isNaN(parseInt(index, 10))) continue

        console.log('index: ', index)
        console.log('this.$v.vendors.$each[index]: ', this.$v.vendors.$each[index])
        errors[index] = {
          vendorName: [],
          partNumber: []
        }
        if (!this.$v.vendors.$each[index].$anyDirty) continue
        // Vendor
        if (
          this.$v.vendors.$each[index].vendorName.$dirty &&
          !this.$v.vendors.$each[index].vendorName.required
        ) errors[index].vendorName = 'Vendor is required'
        if (!this.$v.vendors.$each[index].vendorName.uniqueVendor) errors[index].vendorName = 'Vendors should only be listed once'

        // Part Number
        if (
          this.$v.vendors.$each[index].partNumber.$dirty &&
          !this.$v.vendors.$each[index].partNumber.required
        ) {
          errors[index].partNumber = 'Vendor Part No. is required'
        }
      }

      console.log('RETURNING COMPUTED ERRORS: ', errors)

      return errors
    },
    vendorsMap () {
      return reduce((result, value) => {
        if (value.vendor.id) result[value.vendor.id] = omit('key')(value)
        return result
      })({})(this.vendors)
    },
    ...mapGetters({
      vendorNames: 'vendors/vendorNames',
      existingVendors: 'vendors/vendors',
      getVendor: 'vendors/vendor'
    })
  },

  methods: {
    vendorValidations () {
      return {
        vendors: {
          $each: {
            vendorName: {
              required,
              uniqueVendor: this.uniqueVendor
            },
            partNumber: { required }
          }
        }
      }
    },

    uniqueVendor (value, parentVm) {
      if (value) {
        const vendors = this.vendors.filter(vendor => vendor.vendorName === value)
        if (vendors && vendors.length && vendors.length > 1) {
          return false
        }

        return true
      }
      return true
    },

    addVendor () {
      const newKey = uniqueId(ID_PREFIX)
      this.vendors.push({
        vendorName: null,
        partNumber: null,
        computerEaseNumber: null,
        key: newKey
      })

      this.$nextTick(function () {
        console.log('this: ', this)
        let newInput = this.$refs[`${newKey}__name-input`][0]
        console.log('newInput: ', newInput)
        newInput.$refs.input && newInput.$refs.input.select()
      })
    },

    async saveVendors () {
      console.log('save vendors')
      // Add vendors
      const existingVendors = this.existingVendors
      let vendorsToSave = await this.vendors.reduce(async (previousPromise, curr) => {
        let collection = await previousPromise

        if (curr && !curr.vendorName.trim().length) return collection

        let vendor = existingVendors.find(v => v.name === curr.vendorName.trim())
        let vendorID
        if (!vendor) {
          vendorID = await this.saveVendor({ name: curr.vendorName })
          vendor = this.getVendor(vendorID)
        } else {
          vendorID = vendor.id
        }

        collection[vendorID] = {
          ...omit('key')(curr),
          vendor
        }
        return collection
      }, Promise.resolve({}))

      console.log('vendors TO SAVE: ', vendorsToSave)
      return vendorsToSave
    },

    fillVendors (standardItem) {
      this.vendors = standardItem && standardItem.vendors
        ? Object.values(standardItem.vendors).map(vendor => {
          return {
            key: uniqueId(ID_PREFIX),
            partNumber: vendor.partNumber,
            vendorName: vendor.vendor.name
          }
        })
        : []
      console.log('this.vendors', this.vendors)
    },

    vendorsInput ({ event, field, index, key }) {
      this.delayTouch(this.$v.vendors.$each[index][field])
    },

    ...mapActions({
      saveVendor: 'vendors/add',
      getVendors: 'vendors/get'
    })
  },
  created () {
    this.getVendors()
  }
}
